<template>
  <div class="left-chart-1" id="left-chart-1"></div>
</template>

<script>
import { selectInspectCount } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart1',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const container = document.getElementById('left-chart-1')
      this.chart = this.$echarts.init(container)
      const apiData = await selectInspectCount(this.date)
      const echartsData = []
      if (apiData) {
        apiData.forEach(item => {
          echartsData.push({
            name: item.hxcs_position,
            value: item.yxsysc_bwjccs,
          })
        })
      }
      const options = {
        title: {
          text: '部位检查次数情况',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {},
        legend: {
          type: 'scroll',
          pageIconColor: '#70f3ff',
          pageIconInactiveColor: '#065279',
          bottom: 10,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          bottom: 10,
        },
        series: [
          {
            name: '次数',
            type: 'pie',
            radius: ['40%', '60%'],
            label: {
              formatter: function(data) {
                return data.percent.toFixed(0) + '%'
              },
              show: true,
              textStyle: {
                color: '#fff',
              },
              position: 'inner',
            },
            insideLabel: {
              show: true,
            },
            labelLine: {
              show: false,
            },
            data: echartsData,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-1 {
  width: 100%;
  height: 50%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;
}
</style>
